module.exports = __webpack_public_path__ + "static/img/ent-55.e8ed510.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-55.jpg
// module id = Erm3
// module chunks = 52